import moment from 'moment';
import { useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router';
import { usePagination, useTable } from 'react-table';
import { toast } from 'react-toastify';
import { useAppContext } from '../../../appProvider/contextProvider';
import DeletePrompt from '../../../components/Propmts/deletePrompt';
import SegmentModal from '../../../components/Propmts/segmentPrompt';
import { deleteSegments, getSegments } from '../../../services/segmentService';

import NoDataImage from '../../../assets/images/illustration.svg';
import roundOff from '../../../Util/roundOff';
import HelperComponent from '../../../components/HelperComponent/HelperComponent';


const columns =  [
    {
        Header: 'Name',
        accessor: 'name', // accessor is the "key" in the data
    },
    {
        Header: 'Estimated Reach',
        accessor: 'audience_reach', // accessor is the "key" in the data
        Cell: (props) => roundOff(props.value),
    },
    {
        Header: 'Created On',
        accessor: 'created_at', // accessor is the "key" in the data
        Cell: (props) => moment(props.value).format('MMM DD, YYYY'),
    },
    {
        Header: 'Action',
        accessor: '', // accessor is the "key" in the data
    },
]


const Segments = () => {

    const history = useHistory();

    const { selectedWebsite, 
        isFetching, 
        isMutating,
        setIsBgDisabled
    } = useAppContext();

    const [segments, setSegments] = useState([]);

    const [deletePrompt, setDeletePrompt] = useState(false);

    const [segmentIdSelected, setSegmentIdSelected] = useState(null);

    const [ segmentPrompt, setSegmentPrompt ] = useState(false);

    const [segmentDetails, setSegmentDetails] = useState(null);

    const { refetch } = useQuery(['fetchSegments', selectedWebsite?.id], () => getSegments(selectedWebsite?.id), {
        enabled: !!selectedWebsite,
        onSuccess: (segments) => {
            if(segments.errors) {

            } else {
                setSegments(segments);
            }
        }
    });


    const segmentsData = useTable({
        columns,
        data: segments,
    }, usePagination);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
      } = segmentsData;
      

    const deleteSeg = useMutation(() => {
        return deleteSegments(selectedWebsite?.id, segmentIdSelected);
    }, {
        onSuccess: (data) => {
            if(data.errors) {

            } else {
                const updatedSegments = segments.filter(({id}) => id !== segmentIdSelected);
                setSegments(updatedSegments);
                toast.success('Segment Deleted Successfully');
            }
            setSegmentIdSelected(null);
        }
    })

    const discard = (id) => {
        setSegmentIdSelected(id);
        setDeletePrompt(true);
        setIsBgDisabled(true);
    }

    const onDelete = (event) => {
        event.preventDefault();
        setDeletePrompt(false);
        setIsBgDisabled(false);
        deleteSeg.mutate();
    }

    const onCancel = () =>{
        setDeletePrompt(false);
        setIsBgDisabled(false); 
        setSegmentIdSelected(null)
    }


    const viewSegment = ({original}) => {
        setSegmentDetails({title: original.name, rules:original.rules});
        setSegmentPrompt(true);
        setIsBgDisabled(true)
    }

    const onCloseModal = () => {
        setSegmentDetails(null);
        setSegmentPrompt(false);
        setIsBgDisabled(false);
    }

    const getRows = (cell, row) => {
        if(cell?.column?.Header === 'Action') {
            return  <div className="d-flex">
                <button 
                    className="btn btn-outline mx-1"
                    onClick={() => viewSegment(row)}
                >
                    <i className="icon icon-eye"></i>
                </button>
                <button
                    className="btn btn-danger mx-1"
                    onClick={() => discard(row?.original?.id)}
                >
                    <i className="icon icon-delete"></i>
                </button>
            </div>
        }
        return cell.render('Cell');
    } 


    return <>
        { deletePrompt && <DeletePrompt onDelete={onDelete} onCancel={onCancel} />}
        {segmentPrompt && <SegmentModal 
            segmentDetails={segmentDetails}
            onClose={onCloseModal}
        />}
        <div className="panel full-height">
            <div className="panel-header">
                <div className="d-flex justify-content-between align-items-space-between">
                    <div>
                        <h3 className="mb-0">
                            Segments
                            <HelperComponent
                                component={'Segments'}  
                                href="https://chirpyweb.com/documentation_posts/segments/" />    
                        </h3>
                    </div>
                    <div className="d-flex justify-content-between " style={{gap: '10px'}}>
                        <button className="btn" onClick={() => refetch()} ><i className="icon icon-refresh mr-2"></i> Refresh </button>
                        <button onClick={() => history.push('/create-segment')} className="btn btn-primary"><i className="icon icon-add ml-2"></i> Create</button>                                       
                    </div> 
                </div>                                
            </div>
            <div className="panel-body full-height scrollable_y">
                <div className="d-flex flex-column full-height">
                    <div className="d-flex flex-column full-height">
                        <div className="table-responsive subscription-table full-height">
                            <table className="table table-hover" {...getTableProps()} >
                                <thead>
                                    {
                                        headerGroups.map(headerGroup => (
                                            <tr {...headerGroup.getHeaderGroupProps()}>
                                                {
                                                    headerGroup.headers.map(column => (
                                                        <th {...column.getHeaderProps()}>
                                                            {column.render('Header')}
                                                        </th>
                                                    ))
                                                }
                                            </tr>
                                        ))
                                    }
                                    {/* <tr>
                                        <th>Name</th>   
                                        <th>Reach</th>
                                        <th>Created On</th>
                                        <th>Action</th>
                                    </tr> */}
                                </thead>
                                <tbody {...getTableBodyProps()}>
                                    {   // Loop over the table rows
                                        rows.map(row => {
                                            // Prepare the row for display
                                            prepareRow(row)
                                            return (
                                            // Apply the row props
                                                <tr {...row.getRowProps()}>
                                                    {row.cells.map(cell =>  <td {...cell.getCellProps()}>{getRows(cell, row)}</td>)}
                                                </tr>
                                            )
                                        })
                                    }
                                    {
                                        (!isFetching && !isMutating && segments.length <= 0) &&  <tr>
                                            <td colSpan="6" align="center">
                                                <div className="d-flex flex-column align-items-center justify-content-center mt-5">
                                                    <img src={NoDataImage} className="illustration-image" />
                                                    <h5 className="medium text-dark mt-2">No segment added, please add one</h5>
                                                    <button className="btn btn-primary my-2" onClick={() => history.push('/create-segment')} >Add Segments  </button>
                                                </div>                                                    
                                            </td>
                                        </tr>
                                    }
                                    {/* <tr>
                                        <td>Desktop-subscribers</td>
                                        <td>
                                            <button className="btn btn-outline">Show Estimated Reach</button>
                                            <button className="btn btn-outline"><i className="icon icon-refresh"></i></button>
                                        </td>
                                        <td>Aug 14, 2020</td>
                                        <td className="d-flex">                                                            
                                            <button className="btn btn-outline mx-1"><i className="icon icon-eye"></i></button>
                                            <button className="btn btn-danger mx-1"><i className="icon icon-delete"></i></button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Desktop-subscribers</td>
                                        <td>
                                            <button className="btn btn-outline">Show Estimated Reach</button>
                                            <button className="btn btn-outline"><i className="icon icon-refresh"></i></button>
                                        </td>
                                        <td>Aug 14, 2020</td>
                                        <td className="d-flex">
                                            
                                            <button className="btn btn-outline mx-1"><i className="icon icon-eye"></i></button>
                                            <button className="btn btn-danger mx-1"><i className="icon icon-delete"></i></button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Desktop-subscribers</td>
                                        <td>
                                            <button className="btn btn-outline">Show Estimated Reach</button>
                                            <button className="btn btn-outline"><i className="icon icon-refresh"></i></button>
                                        </td>
                                        <td>Aug 14, 2020</td>
                                        <td className="d-flex">
                                            
                                            <button className="btn btn-outline mx-1"><i className="icon icon-eye"></i></button>
                                            <button className="btn btn-danger mx-1"><i className="icon icon-delete"></i></button>
                                        </td>
                                    </tr> */}
                                </tbody>
                            </table>                                
                        </div>        
                        <div className="d-flex flex-wrap justify-content-between align-items-center">
                            <p className="mb-1">Total {segments.length} entries</p>
                            {/* <div className="mb-1">
                                <button className="btn mr-2" disabled={!canPreviousPage}  onClick={() => previousPage()} ><i className="icon icon-chevron-left mr-2"></i>Prev</button>
                                <button className="btn" disabled={!canNextPage} onClick={() => nextPage()}>Next <i className="icon icon-chevron-right ml-2"></i></button>
                            </div> */}
                        </div>                                
                    </div>  
                </div>                              
            </div>
        </div>

    </>
};


export default Segments;